"use client";

import { forwardRef, type SelectHTMLAttributes } from "react";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

const SELECT_CLASSES =
  "peer w-full appearance-none rounded-[var(--fz-field-radius)] border border-[var(--fz-field-border)] bg-[var(--fz-field-bg)] px-3 py-2.5 pr-10 text-sm text-[var(--fz-field-text)] outline-none transition-colors placeholder:text-[var(--fz-field-placeholder)] hover:border-[var(--fz-field-border-hover)] focus-visible:border-[var(--fz-field-border-focus)] focus-visible:ring-2 focus-visible:ring-[var(--fz-field-focus-ring)] focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-[var(--fz-field-disabled-bg)] disabled:text-[var(--fz-field-disabled-text)] read-only:bg-[var(--fz-field-readonly-bg)] aria-invalid:border-[var(--fz-field-error)] aria-invalid:focus-visible:border-[var(--fz-field-error)] aria-invalid:focus-visible:ring-[var(--fz-field-error)]";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className = "", children, multiple, ...props },
  ref,
) {
  return (
    <span className="relative block w-full">
      <select
        {...props}
        ref={ref}
        multiple={multiple}
        data-fz-field="select"
        className={`${SELECT_CLASSES} ${className}`}
      >
        {children}
      </select>
      {!multiple ? (
        <svg
          aria-hidden="true"
          viewBox="0 0 20 20"
          fill="none"
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--fz-field-icon)] peer-disabled:text-[var(--fz-field-disabled-text)]"
        >
          <path d="m5 7.5 5 5 5-5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : null}
    </span>
  );
});
